import Richtext from '@tmh-website/components/shared/Richtext';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  @media (${props => props.theme.breakpoint.sm.up}) {
    width: auto;
    min-width: 380px;
  }
`;

export const Text = styled(Richtext)`
  margin-bottom: 16px;
`;
